import { Menu, X } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <header className="flex justify-between items-center p-6 border-b relative">
      <Link
        to="/"
        className="hidden md:flex items-center gap-2 font-bold text-lg hover:opacity-80"
      >
        <div className="w-2 h-2 bg-teal-600 rounded-full" aria-hidden="true" />
        Rita Neves{' '}
        <span className="font-normal">/ SENIOR FRONTEND DEVELOPER</span>
      </Link>

      <Link
        to="/"
        className="md:hidden flex items-center gap-2 font-bold text-sm hover:opacity-80"
      >
        <div className="w-2 h-2 bg-teal-600 rounded-full" aria-hidden="true" />
        RN <span className="font-normal">/ SENIOR FRONTEND DEVELOPER</span>
      </Link>
      {/* Desktop Nav */}
      <nav
        aria-label="Main navigation"
        className="hidden md:flex space-x-6 text-sm font-medium"
      >
        <Link to="/" className="hover:text-teal-600">
          ABOUT ME
        </Link>
        <Link to="/resume" className="hover:text-teal-600">
          RESUME
        </Link>
        <Link to="/projects" className="hover:text-teal-600">
          PROJECTS
        </Link>
        <Link to="/reviews" className="hover:text-teal-600">
          PERFORMANCE REVIEWS
        </Link>
      </nav>

      {/* Mobile Menu Toggle */}
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="md:hidden text-gray-700"
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        {menuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Nav */}
      {menuOpen && (
        <nav
          ref={menuRef}
          aria-label="Mobile navigation"
          className="absolute top-full right-6 mt-2 bg-white border rounded-md shadow-md flex flex-col w-48 p-4 space-y-2 text-sm font-medium z-50"
        >
          <Link to="/" className="hover:text-teal-600">
            ABOUT ME
          </Link>
          <Link to="/resume" className="hover:text-teal-600">
            RESUME
          </Link>
          <Link to="/projects" className="hover:text-teal-600">
            PROJECTS
          </Link>
          <Link to="/reviews" className="hover:text-teal-600">
            PERFORMANCE REVIEWS
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;
